import { useContext, useEffect, useState } from "react";
import { Button, Input } from "../../../ui";
import { Context } from "../../../../context/Context";
import { useAccess } from "../../../../access/hooks/useAccess";
import { getBillingSettingsAPI, updateBillingSettingsAPI } from "../../../../utils/api/billing";
import { useBillingAdminText } from "../billingAdminI18n";

const TaxPanel = ({ canManage, onChanged }) => {
  const { lang } = useContext(Context);
  const { can } = useAccess();
  const text = useBillingAdminText(lang);
  const token = localStorage.getItem("auth-token");
  const [form, setForm] = useState({ vatRegistered: true, rate: "15", taxNumber: "", reason: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    getBillingSettingsAPI(token)
      .then((result) =>
        setForm({
          vatRegistered: Boolean(result.data?.vatRegistered),
          rate: String((result.data?.defaultVatRateBps ?? 1500) / 100),
          taxNumber: result.data?.taxNumber || "",
          reason: "",
        }),
      )
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [token]);

  const save = async () => {
    if (!can("billing.admin.settings.manage")) return;
    if (!form.reason.trim()) {
      setError(text.settings.vatModal.reasonRequired);
      return;
    }
    setSaving(true);
    setError("");
    setMessage("");
    try {
      await updateBillingSettingsAPI(token, {
        vatRegistered: form.vatRegistered,
        defaultVatRateBps: Math.round(Number(form.rate) * 100),
        taxNumber: form.taxNumber || null,
        reason: form.reason,
      });
      setMessage(text.settings.saved);
      setForm((current) => ({ ...current, reason: "" }));
      onChanged?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="billing-settings-panel">
      <p className="billing-settings-panel-note">{text.settings.vatModal.scopeNote}</p>
      {error && <div className="billing-error">{error}</div>}
      {message && <div className="billing-success">{message}</div>}
      {loading ? (
        <div className="billing-loading">{text.common.loading}</div>
      ) : (
        <div className="billing-plan-modal-form">
          <label className="billing-inline-toggle-row">
            <input
              type="checkbox"
              checked={form.vatRegistered}
              disabled={!canManage}
              onChange={(event) => setForm((current) => ({ ...current, vatRegistered: event.target.checked }))}
            />
            {text.settings.vatModal.registered}
          </label>
          <Input
            label={text.settings.vatModal.rate}
            type="number"
            value={form.rate}
            disabled={!canManage}
            onChange={(event) => setForm((current) => ({ ...current, rate: event.target.value }))}
          />
          <Input
            label={text.settings.vatModal.taxNumber}
            value={form.taxNumber}
            disabled={!canManage}
            onChange={(event) => setForm((current) => ({ ...current, taxNumber: event.target.value }))}
          />
          <Input
            label={text.settings.vatModal.reason}
            value={form.reason}
            disabled={!canManage}
            onChange={(event) => setForm((current) => ({ ...current, reason: event.target.value }))}
            required
          />
          {canManage && (
            <div className="billing-modal-actions">
              <Button appearance="filled" loading={saving} onClick={save}>
                {text.settings.vatModal.save}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TaxPanel;
